import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/lib/i18n";
import LangToggle from "@/components/LangToggle";
import { BrandLogo } from "@/components/shared";

export default function AuthShell({ title, subtitle, children, footer }) {
  const { t } = useI18n();
  return (
    <div className="min-h-screen ec-bg flex flex-col">
      <div className="flex items-center justify-between p-5 max-w-6xl mx-auto w-full">
        <Link to="/" className="flex items-center gap-2 font-head font-extrabold text-lg" data-testid="auth-brand-link">
          <BrandLogo size="w-12 h-12" text={t("brand")} textClass="text-lg" testid="auth-brand-logo" />
        </Link>
        <LangToggle compact />
      </div>
      <div className="flex-1 flex items-center justify-center px-4 pb-16">
        <div className="w-full max-w-md">
          <div className="ec-card p-8 animate-fadeUp glow-orange">
            <h1 className="font-head text-2xl font-bold text-white">{title}</h1>
            {subtitle && <p className="text-gray-400 text-sm mt-1 mb-6">{subtitle}</p>}
            {children}
          </div>
          {footer && <div className="text-center text-sm text-gray-400 mt-5">{footer}</div>}
        </div>
      </div>
    </div>
  );
}
